import { Tag } from "antd"
import { listStaffEnhanceVideoTasks } from "~/api/staff"
import {
  getVideoTaskColumns,
  VideoTaskListPage,
} from "~/pages/Staff/VideoTaskList"

const columns = getVideoTaskColumns<API.Staff.StaffEnhanceVideoTaskItem>({
  doneLabel: "增强完成",
  failedLabel: "增强失败",
  resultTitle: "增强结果",
  settingColumns: [
    {
      title: "增强版本",
      dataIndex: "enhance_type",
      width: 120,
      render: (type: API.Task.EnhanceVideoType) => (
        <Tag color={type === "advanced" ? "purple" : "blue"}>
          {type === "advanced" ? "高阶版" : "经济版"}
        </Tag>
      ),
    },
    {
      title: "目标参数",
      width: 140,
      render: (_, record) => `${record.resolution} · ${record.fps}fps`,
    },
  ],
})

export const StaffEnhanceVideoTaskList = () => (
  <VideoTaskListPage
    title="画质提升任务"
    description="查看视频画质提升任务的处理状态、输入输出视频和计费积点。"
    columns={columns}
    fetchPage={listStaffEnhanceVideoTasks}
    errorMessage="画质提升任务加载失败，请稍后重试"
  />
)
